import POSPage from '@/pages/POSPage'

export default function VentasPage() {
  return <POSPage view="cashier" />
}

